<div class="flex min-h-full h-screen">
  <div class="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6  lg:px-20 xl:px-24">
    <div class="mx-auto w-full max-w-xl">
      <div>
        <img class="h-40 w-auto" src="assets/images/logo_black.svg" alt="RS Saddles">
        
        
      </div>

      <div class="mt-10">
        <div>
          <form *ngIf="!forgotPasswordOn" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
            <div>
              <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
              <div class="mt-2">
                <input formControlName="email"   id="email" name="email" type="email" autocomplete="email" required class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6">
              </div>
              <div *ngIf="loginForm.get('email').invalid && loginForm.get('email').touched" class="text-red-500 text-sm">
                Please enter a valid email.
              </div>
            </div>

            <div>
              <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
              <div class="mt-2">
                <input formControlName="password"  id="password" name="password" type="password" autocomplete="current-password" required class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6">
              </div>
              <div *ngIf="loginForm.get('password').invalid && loginForm.get('password').touched" class="text-red-500 text-sm">
                Password is required.
              </div>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center">
                
                
              </div>

              <div class="text-sm leading-6">
                <span (click)="forgotPasswordOn = true" class="font-semibold text-black hover:text-indigo-500 cursor-pointer">Forgot password?</span>
              </div>
            </div>

            <div>
              <button [disabled]="loginForm.invalid" type="submit" class="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black">Sign in</button>
            </div>
          </form>

          <form *ngIf="passwordResetForm && forgotPasswordOn" class="mt-8 space-y-6" action="#" method="POST" [formGroup]="passwordResetForm" (ngSubmit)="resetPassword(passwordResetForm.value)">
            <input type="hidden" name="remember" value="true">
            <div class="-space-y-px rounded-md shadow-sm">
              <div>
                <label for="email-address" class="sr-only">Email address</label>
                <input formControlName="email" id="email-address" name="email" type="email" autocomplete="email" required class="relative block w-full rounded-t-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="Email address">
              </div>
              
            </div>
      
            <div class="flex items-center justify-between">
            
              <span></span>
      
              <div class="text-sm">
                <a (click)="forgotPasswordOn = false" class="font-medium cursor-pointer text-indigo-600 hover:text-indigo-500">Cancel</a>
              </div>
            </div> 
      
            <div>
              
              <button type="submit" [disabled]="passwordResetForm.invalid" class="disabled:opacity-40 disabled:pointer-events-none group relative flex w-full justify-center rounded-md bg-accent py-2 px-3 text-sm font-semibold text-white hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                <span class="absolute inset-y-0 left-0 flex items-center pl-3">
                  <svg class="h-5 w-5 text-white group-hover:white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clip-rule="evenodd" />
                  </svg>
                </span>
                Send Password Reset Link
              </button>
            </div>
          </form>

          <div *ngIf="signInMessage" class=" p-4 mt-4 text-sm text-center " [ngClass]="{
            'bg-red-50 border border-red-500 text-red-900': signInMessage && signInMessage.status === 'error',
            'bg-green-50 border border-green-500 text-green-900': signInMessage && signInMessage.status === 'success',
            }">{{ signInMessage.message }}</div>
        </div>

        
      </div>
    </div>
  </div>
  <div class="relative hidden w-0 flex-1 lg:block">
    <img class="absolute inset-0 h-full w-full object-cover" src="assets/images/brown_back_4.jpg" alt="">
  </div>
</div>
